export default __webpack_public_path__ + "static/fingernail-dceb955a44f5645526f789a76a45b403.png";